import { BellAlertIcon } from "@heroicons/react/20/solid";
import { formatDistanceToNow, parseISO } from "date-fns";
import { Notification } from "./NotificationList";

export default function NotificationItem({
  notification,
}: {
  notification: Notification;
}) {
  const timeAgo = formatDistanceToNow(parseISO(notification.created_at), {
    addSuffix: true,
    includeSeconds: true,
  });

  return (
    <div className="flex items-start space-x-3 p-4 hover:bg-gray-50">
      <div className="flex-shrink-0">
        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
          <img src="/avatar.png" alt="Notification" />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex gap-2 items-center">
          <p className="text-sm font-medium text-gray-900">System</p>
          <span className="text-xs text-gray-500">{timeAgo}</span>
        </div>
        <p className="text-sm text-gray-500">{notification.body}</p>
      </div>
      <div className="flex-shrink-0">
        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
      </div>
    </div>
  );
}
